module.exports = __webpack_public_path__ + "img/role04.a99a819f.png";